import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const bottles = [{
  name: "The Daily Bar",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637664/img/lixr_bottle_citrus_bloom.png"
}, {
  name: "The Guest Soap",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637664/img/lixr_bottle_tropical_sun.png"
}, {
  name: "The Hotel Blend",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637664/img/lixr_bottle_berry_garden.png"
}];
export default function LixrExperienceBegins() {
  return <section data-section-id="224734" id="luxury-soaps-for-sensitive-skin" className="relative min-h-screen flex items-center justify-center bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637664/img/lixr_cinematic_liquid_bg.png)] bg-cover bg-center opacity-10 mix-blend-multiply" />
        <div className="absolute inset-0 bg-gradient-to-b from-background/95 via-background/40 to-background" />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-transparent to-background opacity-60" />
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center w-full max-w-7xl mx-auto px-4 py-24 text-center">
        {}
        <h1 className="text-5xl md:text-7xl lg:text-8xl xl:text-9xl font-default font-light tracking-tight mb-20 text-transparent bg-clip-text bg-gradient-to-b from-foreground to-foreground/70 drop-shadow-sm uppercase">
          Luxury soaps for sensitive skin
        </h1>

        {}
        <div className="flex flex-col md:flex-row items-center justify-center gap-16 md:gap-24 lg:gap-32 mb-24">
          {bottles.map((bottle, i) => <div key={i} data-index={i} className="group relative flex flex-col items-center cursor-pointer">
              {}
              <div className="relative w-32 md:w-48 lg:w-56 aspect-[1/2.5] transition-all duration-700 ease-out group-hover:-translate-y-6 group-hover:scale-105">
                {}
                <div className="absolute inset-0 bg-accent/20 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
                <img src={bottle.img} alt={bottle.name} className="absolute inset-0 w-full h-full object-contain drop-shadow-xl" />
              </div>
              
              {}
              <span className="mt-8 text-sm md:text-base font-mono tracking-wider uppercase text-muted-foreground group-hover:text-primary transition-colors duration-300">
                {bottle.name}
              </span>
            </div>)}
        </div>

        {}
        <div className="relative inline-block group mt-8">
          {}
          <div className="absolute -inset-2 bg-accent/10 rounded-full blur-xl opacity-70 group-hover:opacity-100 transition duration-1000 animate-pulse" />
          
          <Button asChild size="lg" className="relative z-10 rounded-full px-12 h-16 text-lg font-default tracking-wider bg-primary border border-primary text-primary-foreground hover:bg-transparent hover:text-primary hover:border-primary transition-all duration-500 shadow-lg">
            <Link to="#">Shop the Ritual</Link>
          </Button>
        </div>
      </div>
    </section>;
}